import Vue from "vue";
import Vuex from "vuex";
import Qs from 'qs';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      qureydata:Qs.parse(location.search.substring(1)),
      windowUrl:window.location.href.split('#')[0],
      main:"#0072F6",
      bidmain:"#206AFF",
	  red:"#FF6350",
	  red_1:"#DA0A1B",
	  white:"#fff",
	  black:"#011133",
	  grey:"#A1A1A1",
	  CDgrey:"#cdcdcd",
	  CCgrey:"#cccccc",
      grey_7:'#9799AB',
	  blue:"#3DA6F0",
	  blue_1:"#2878FF",
      blue_3:"#0055FF",//智能客服
      blue_4:"#0055ff17",//透明
	  green:"#4dd865",
      yellow:"#F39F1F",
	  yellow_2:"#F2991D",
      yellow_3:"#FF6600",
	  userdata:'',//个人信息
      shopdata:'',//店铺信息
      configdata:'',//配置信息
      signdata:'',//授权信息
      hnewdata:'',//
      isinit:false,//是否更新信息
      // issign:'',//是否授权
	  loginstatus:'',//是否登录
      ishometip:false,//首页是否提示
      ishomepop:true,//首页是否弹窗
      // positionObj:'',
      sharePopup:false,
      catdata:'',//分类信息
      fielddata:'',//字段信息
      branddata:'',//品牌信息
      
  },
  mutations: {
	  SET_USERDATA(state,userdata){ //个人信息
	  	state.userdata = userdata
	  },
      SET_SHOPDDATA(state,shopdata){ //店铺信息
      	state.shopdata = shopdata
      },
      SET_CONFIGDATA(state,configdata){//配置信息
        state.configdata=configdata;
      },
      SET_SIGNDATA(state,signdata){//配置信息
        state.signdata=signdata;
      },
      SET_ISINIT(state,isinit){//是否更新信息
      	state.isinit = isinit
      },
      // SET_ISINIT(state,isinit){//是否更新信息
      // 	state.isinit = isinit
      // },
      SET_HNEWDATA(state,hnewdata){//首页新闻列表
      	state.hnewdata = hnewdata
      },
	  SET_LOGINSTATUS(state,loginstatus) { //是否登录
	  	state.loginstatus=loginstatus
	  },
	  SET_ISHOMETIP(state,ishometip) { //首页是否提示
	  	state.ishometip=ishometip
	  },
      SET_ISHOMEPOP(state,ishomepop) { //首页是否弹窗
      	state.ishomepop=ishomepop
      },
      SET_SHAREPOPUP(state,sharePopup){//分享页面
        state.sharePopup=sharePopup;
      },
      SET_CATDATA(state,catdata){//分类列表
      	state.catdata = catdata
      },
      SET_FIELDDATA(state,fielddata){//字段列表
      	state.fielddata = fielddata
      },
      SET_BRANDDATA(state,branddata){//品牌列表
      	state.branddata = branddata
      },
  },
  actions: {
	  set_userdata({ commit }, userdata) {//个人信息
	  	commit("SET_USERDATA", userdata)
	  },
      set_shopdata({ commit }, shopdata) {//店铺信息
      	commit("SET_SHOPDDATA", shopdata)
      },
      set_configdata({ commit }, configdata) {//配置信息
      	commit("SET_CONFIGDATA", configdata)
      },
      set_signdata({ commit }, signdata) {//授权信息
      	commit("SET_SIGNDATA", signdata)
      },
      set_hnewdata({ commit }, hnewdata) {//首页新闻
      	commit("SET_HNEWDATA", hnewdata)
      },
      set_isinit({ commit }, isinit) {// 是否更新信息
      	commit("SET_ISINIT", isinit)
      },
	  set_loginstatus({ commit },loginstatus){//是否登录
	  	commit("SET_LOGINSTATUS",loginstatus)
	  },
      set_ishometip({ commit }, ishometip) {//首页是否提示
        commit("SET_ISHOMETIP",ishometip)
      },
      set_ishomepop({ commit }, ishomepop) {//首页是否弹窗
        commit("SET_ISHOMEPOP",ishomepop)
      },
      set_sharePopup({ commit }, sharePopup) {//分享页面
        commit("SET_SHAREPOPUP",sharePopup)
      },
      set_catdata({ commit }, catdata) {//首页新闻
      	commit("SET_CATDATA", catdata)
      },
      set_fielddata({ commit }, fielddata) {//首页新闻
      	commit("SET_FIELDDATA", fielddata)
      },
      set_branddata({ commit }, branddata) {//首页新闻
      	commit("SET_BRANDDATA", branddata)
      },
  },
  modules: {}
});
